import { Component, Input } from '@angular/core';
import { RequisitionModalComponent } from '../requisition-modal/requisition-modal.component';
import { Subscription } from 'rxjs';
import { TemplateDocumentType, DocumentStatus, DocumentTemplateModel } from 'src/app/core/models/document/document-template-model';
import { CustomFieldGroupModel } from 'src/app/core/models/myfile/custom-field-group.model';
import { CustomFieldModel } from 'src/app/core/models/document/custom-field-model';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-marketplace-modal',
  templateUrl: './marketplace-modal.component.html',
  styleUrls: ['./marketplace-modal.component.scss']
})

export class MarketplaceModalComponent extends RequisitionModalComponent {


  @Input() documentTemplate: DocumentTemplateModel = new DocumentTemplateModel;

  billingFrequency: CustomFieldModel | undefined = undefined;
  trialPeriod: CustomFieldModel | undefined = undefined;
  productType: CustomFieldModel | undefined = undefined;
  serviceFee: CustomFieldModel | undefined = undefined;
  CFamount: CustomFieldModel | undefined = undefined;

  totalAmountCharged: number = 0; 

  override ngOnInit(): void {
    if (this.documentTemplate && this.documentTemplate.customFields) {
      this.myfileCustomFieldsGroups.push(this.defaultCustomFieldGroup);
      this.documentTemplate.customFields.forEach((customField: any, index: number) => {
        if (customField.dataType == 2) {
          customField.value = this.dateRequestFormat(customField.value);
        }

        if (customField.groupName && customField.groupName != "") {
          var groupDoesNotExists: boolean = true;
          this.myfileCustomFieldsGroups.forEach(customFieldGroup => {
            if (groupDoesNotExists && customFieldGroup.groupName == customField.groupName) {
              groupDoesNotExists = false
              customFieldGroup.group.push(customField);
            }
          })
          if (groupDoesNotExists) {
            this.defaultCustomFieldGroup = new CustomFieldGroupModel();
            this.defaultCustomFieldGroup.groupName = customField.groupName;
            this.defaultCustomFieldGroup.group.push(customField);
            this.myfileCustomFieldsGroups.push(this.defaultCustomFieldGroup)
          }
        } else {
          this.defaultCustomFieldGroup = this.myfileCustomFieldsGroups[0];
          this.defaultCustomFieldGroup.group.push(customField);
          this.myfileCustomFieldsGroups[0] = this.defaultCustomFieldGroup;
        }
      });
    }

    this.setSubGroups();

    if (this.myfileCustomFieldsGroups[0] && this.myfileCustomFieldsGroups[0].subgroups[0] && this.myfileCustomFieldsGroups[0].subgroups[0].group && this.myfileCustomFieldsGroups[0].subgroups[0].group.length == 0) {
      this.activeIdIndex = 1;
    }

    if (this.documentTemplate) {
      if (this.priceTotal == 0) {
        this.priceTotal = this.documentTemplate.price + this.documentTemplate.processingFee;
      }

      this.billingFrequency = this.documentTemplate.customFields?.find(x => x.name === 'BillingFrequency');
      this.trialPeriod = this.documentTemplate.customFields?.find(x => x.name === 'TrialPeriodDays');
      this.productType = this.documentTemplate.customFields?.find(x => x.name === 'ProductType');
      this.serviceFee = this.documentTemplate.customFields?.find(x => x.name === 'ServiceFee');
      this.CFamount = this.documentTemplate.customFields?.find(x => x.name === 'Amount');

      this.calculateStripeFee(this.CFamount);
    }

  }


  override save() {
    this.submitted = true;
    if (this.validate()) {
      this.purchase();
      this.submitted = false;
    } else {
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    }
  }

  override validate(): boolean {

    this.myfile.customFields?.forEach((currentValue) => {
      if (
        currentValue.value == null
        || currentValue.value == ''
      ) {
        currentValue.value = "";
      }
    });
    return true;
  }

  override purchase() {

    this.submitted = true;
    if (this.validate()) {
      this.submitted = false;
      this.spinnerIsShown = true;

      this.checkoutModalService.openModal(this.documentTemplate, TemplateDocumentType.Marketplace, this.productType?.value);
      var sub: Subscription = this.checkoutModalService.modelChanged.subscribe((result: boolean) => {

        if (result === true) {
          this.close();
        }
        this.spinnerIsShown = false;
        sub.unsubscribe();
      })

    } else {
      this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
    }
  }

  calculateStripeFee(amount: CustomFieldModel | undefined) {
    if (amount != undefined &&  this.serviceFee) {
      this.serviceFee.value = GlobalComponent.stripeFeeCalculation(Number(amount.value));
      this.totalAmountCharged = Number(amount.value)+ Number(this.serviceFee.value);
    }
  }

}
